<span
	class="uppercase text-background text-xs px-1 -pr-0.5 rounded bg-primary font-semibold ml-1 tracking-wide"
>
	Pro
</span>
